module.exports = __webpack_public_path__ + "img/magnifier.60f8c0f2.png";